<template>
  <div class="login">
    <div class="login_school_icon">
      <img alt="" src="../assets/imgs/loginSchoolIconNew.png" width="726">
    </div>
    <div class="login_systmeName">2026年中招体育、艺术、科技特长生报名</div>
    <div class="select-enter">
      <div @click="actionFill('VUE_APP_BATCHID_SPORT')">
        <img alt="" height="170px" src="../assets/imgs/sport.png" width="285px">
      </div>
      <div @click="actionFill('VUE_APP_BATCHID_ART')">
        <img alt="" height="170px" src="../assets/imgs/art.png" width="285px">
      </div>
      <div @click="actionFill('VUE_APP_BATCHID_SCIENCE')">
        <img alt="" height="170px" src="../assets/imgs/science.png" width="285px">
      </div>
    </div>
    <div class="support-footer">
      <div class="support-title">技术支持</div>
      <div class="support-grid">
        <div class="support-item">
          <span class="support-label">体育报名咨询：</span>
          <span class="support-value">66526199</span>
        </div>
        <div class="support-item">
          <span class="support-label">艺术报名咨询：</span>
          <span class="support-value">66526199</span>
        </div>
        <div class="support-item">
          <span class="support-label">科技报名咨询：</span>
          <span class="support-value">66526016、66526150</span>
        </div>
        <div class="support-item">
          <span class="support-label">平台技术咨询：</span>
          <span class="support-value">66526075</span>
        </div>
      </div>
      <div class="support-time">咨询时间：周一至周五上午 9:00–11:00，下午 14:30–16:30</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Form, FormItem, Input } from 'element-ui'
import { encryptWithSignature } from "@/util";

Vue.use(Form).use(FormItem).use(Input).use(Button)
export default {
  name: 'home',
  methods: {
    actionFill (key) {
      const encoded = encryptWithSignature(key, 60 * 60 * 24) // 10分钟有效
      this.$router.push({
        path: '/login',
        query: {
          batchId: encoded
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  min-height: 100vh;
  background: #EDF3F7;
  padding-top: 4%;
  padding-bottom: 4%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .login_school_icon {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .login_systmeName {
    text-align: center;
    color: #474747;
    font-size: 32px;
  }

  .select-enter {
    margin-top: 170px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 50px;

    img {
      cursor: pointer;
    }
  }

  .support-footer {
    margin-top: 40px;
    text-align: center;

    .support-title {
      font-size: 15px;
      font-weight: bold;
      color: #555;
      margin-bottom: 12px;
      letter-spacing: 2px;
    }

    .support-grid {
      display: inline-flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 8px 40px;
      margin-bottom: 10px;
    }

    .support-item {
      font-size: 13px;
      color: #666;

      .support-label {
        color: #888;
      }

      .support-value {
        color: #333;
        font-weight: 500;
      }
    }

    .support-time {
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
